const LISTING_TYPES = {
  RENTAL: 'For Rent',
  ROOM: 'Room for Rent',
  SALE: 'For Sale',
} as const;

const PROPERTY_TYPES = {
  COMMUNITY: 'Entire Apartment Community',
  CONDO: 'Condo / Apartment Unit',
  HOUSE: 'House',
  TOWNHOUSE: 'Townhouse',
} as const;

const { RENTAL, ROOM, SALE } = LISTING_TYPES;
const { COMMUNITY, CONDO, HOUSE, TOWNHOUSE } = PROPERTY_TYPES;

const PROPERTY_CODES_BY_TYPE = {
  [COMMUNITY]: 1,
  // not currently using these two
  // GARDEN: 2,
  // MEDIUM: 3,
  [CONDO]: 5,
  [HOUSE]: 6,
  [TOWNHOUSE]: 7,
} as const;

const LISTING_CODES_BY_TYPE = {
  [RENTAL]: 1,
  [SALE]: 2,
  [ROOM]: 5,
} as const;

const PROPERTY_TYPES_BY_CODE: Record<number, string> = {
  1: COMMUNITY,
  2: COMMUNITY,
  3: COMMUNITY,
  5: CONDO,
  6: HOUSE,
  7: TOWNHOUSE,
};

const LISTING_TYPES_BY_CODE = {
  1: RENTAL,
  2: SALE,
  5: ROOM,
};

// Maps from display label to backend enum name (PropertyType / ListingType).
// Note: "Entire Apartment Community" maps to LARGE — COMMUNITY is a virtual
// frontend-only grouping; backend's PropertyType enum has LARGE/GARDEN/MEDIUM
// for community types but only LARGE is accepted by the create endpoint.
const PROPERTY_ENUM_BY_TYPE: Record<(typeof PROPERTY_TYPES)[keyof typeof PROPERTY_TYPES], string> = {
  [COMMUNITY]: 'LARGE',
  [CONDO]: 'CONDO',
  [HOUSE]: 'HOUSE',
  [TOWNHOUSE]: 'TOWNHOUSE',
};

const LISTING_ENUM_BY_TYPE: Record<(typeof LISTING_TYPES)[keyof typeof LISTING_TYPES], string> = {
  [RENTAL]: 'RENTAL',
  [SALE]: 'SALE',
  [ROOM]: 'ROOM',
};

const PropertyConstants = {
  PROPERTY_CODES_BY_TYPE,
  PROPERTY_TYPES,
  LISTING_TYPES,
  LISTING_CODES_BY_TYPE,
  PROPERTY_TYPES_BY_CODE,
  LISTING_TYPES_BY_CODE,
  PROPERTY_ENUM_BY_TYPE,
  LISTING_ENUM_BY_TYPE,
};

export type PropertyTypesValues = (typeof PROPERTY_TYPES)[keyof typeof PROPERTY_TYPES];

export { PropertyConstants };
